<template>
  <div class="feedbackdetails">
    <div class="feedbackdetails_1" v-if="info">
      <img v-if="info.dealstatus == 1" class="static" src="../../assets/images/untreated.png">
      <img v-if="info.dealstatus == 0" class="static" src="../../assets/images/processed.png">
      <div class="header">
        <p>{{info.type}}</p>
        <div class="time">
          <span>反馈人：{{info.smallname}}</span>
          <span>{{info.addtime.replace(/-/g, '/')}}</span>
        </div>
      </div>
      <div class="content">
        <div class="phone" v-if="info.mobiletype && info.mobiletype != undefined && info.mobiletype != 'undefined' && info.mobiletype != null && info.mobiletype != 'null'">
          <span>手机型号：</span>
          <span>{{info.mobiletype}}</span>
        </div>
        <div class="phone" v-if="info.contactway && info.contactway != undefined && info.contactway != 'undefined' && info.contactway != null && info.contactway != 'null'">
          <span>联系方式：</span>
          <span>{{info.contactway}}</span>
        </div>
        <div class="content_1">
          <span>反馈内容：</span>
          <p>{{info.content}}</p>
          <div class="img" v-if="info.img_paths.length">
            <img v-for="(item, index) of info.img_paths" @click="preview(index)" v-lazy="item">
          </div>
        </div>
      </div>
    </div>
    <div class="result" v-if="info && info.dealstatus == 1">
      <div class="title">
        <p>反馈结果</p>
        <span>{{info.opertime.replace(/-/g, '/')}}</span>
      </div>
      <div class="result_content">
        {{info.opermem}}
      </div>
    </div>
<!--    v-if="info && info.dealstatus == 1"-->
    <div class="score" v-if="info && info.dealstatus == 1">
      <p>您对本次反馈是否满意</p>
      <div class="btnbox">
        <button class="btn no" :class="{'red': noface}" @click="scoreClick(1)">
          <img v-if="noface" src="../../assets/images/nofacered.png">
          <img v-if="!noface" src="../../assets/images/nofacegray.png">不满意</button>
        <button class="btn yes" :class="{'red': yesface}" @click="scoreClick(2)">
          <img v-if="yesface" src="../../assets/images/yesfacered.png">
          <img v-if="!yesface" src="../../assets/images/yesfacegray.png">满意</button>
        <div class="mark" v-if="info.evaluatestatus != 0"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { fenxiang } from '../../assets/common/js/config'
import { ImagePreview } from 'vant'
import Vue from 'vue'
Vue.use(ImagePreview)
export default {
  name: 'feedbackDetails',
  data: function () {
    return {
      id: this.$route.query.id ? this.$route.query.id : '',
      noface: false,
      yesface: false,
      info: null
    }
  },
  mounted: function () {
    fenxiang({path: 'feedbackdetails'})
    this.getData()
  },
  methods: {
    getData: function () {
      var that = this
      var url = that.$ajax.getIdeaInfo_URL+'?id=' + that.id
      that.$customRequestAjax(url)
        .then(function (res) {
          if (res.data.code == 200) {
            that.info = res.data.info
            if (that.info.evaluatestatus == 1) {
              that.yesface = true
              that.noface = false
            } else if (that.info.evaluatestatus == 2) {
              that.noface = true
              that.yesface = false
            }
          }
        })
    },
    scoreClick: function (type) {
      var that = this, url = this.$ajax.dealIdea_URL, result = ''
      switch (type) {
        case 1:
          result = 2
          break
        case 2:
          result = 1
          break
      }
      var data = {
        id: that.id,
        result: result
      }
      that.$customRequestAjax.post(url, data)
        .then(function (res) {
          if (res.data.code == 200) {
            switch (type) {
              case 1:
                that.noface = !that.noface
                that.yesface = false
                break
              case 2:
                that.yesface = !that.yesface
                that.noface = false
                break
            }
          }
        })
    },
    preview (index) {
      var imgArr, newImgArr
      imgArr = this.info.img_paths
      newImgArr = []
      imgArr.map(item => {
        if (item && item != undefined) {
          newImgArr.push(item)
        }
      })
      ImagePreview({
        images: newImgArr,
        startPosition: index,
        closeOnPopstate: true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.feedbackdetails {
  margin: 0.1rem 0.11rem;
  .feedbackdetails_1 {
    border-radius: 0.04rem;
    background: #fff;
    position: relative;
    >img {
      position: absolute;
      right: 0;
      top: 0;
      width: 0.67rem;
      height: 0.67rem;
    }
    .header {
      padding: 0.1rem 0.11rem;
      border-bottom: 0.01rem solid #EFEFEF;
      p {
        padding-top: 0.1rem;
        font-size: 0.15rem;
        color: #222222;
        margin-bottom: 0.03rem;
      }
      .time {
        font-size: 0.11rem;
        color: #999999;
        margin-bottom: 0.07rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        span {
          display: block;
          &:first-of-type {
            margin-right: 0.35rem;
            width: 34%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }
    .content {
      padding: 0.14rem 0.11rem 0.11rem;
      .phone {
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        margin-bottom: 0.14rem;
        span {
          font-size: 0.13rem;
          &:first-of-type {
            color: #000000;
            margin-right: 0.1rem;
          }
          &:last-of-type {
            color: #999999;
          }
        }
      }
      .content_1 {
        span {
          font-size: 0.13rem;
          color: #000000;
          margin-bottom: 0.1rem;
          display: block;
        }
        p {
          color: #444444;
          font-size: 0.13rem;
          margin-bottom: 0.1rem;
        }
        .img {
          display: flex;
          display: -webkit-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -o-flex;
          img {
            width: 0.63rem;
            height: 0.63rem;
            margin-right: 0.04rem;
            &:last-of-type {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
  .result {
    background: #fff;
    margin-top: 0.1rem;
    padding: 0.11rem;
    border-radius: 0.04rem;
    .title {
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      -o-justify-content: space-between;
      padding-bottom: 0.1rem;
      border-bottom: 0.01rem solid #EFEFEF;
      p {
        font-size: 0.15rem;
        color: #222222;
      }
      span {
        color: #999999;
        font-size: 0.11rem;
      }
    }
    .result_content {
      color: #444444;
      font-size: 0.13rem;
      margin-top: 0.1rem;
    }
  }
  .score {
    background: #fff;
    margin-top: 0.1rem;
    padding: 0.11rem;
    border-radius: 0.04rem;
    p {
      color: #222222;
      font-size: 0.15rem;
      margin-bottom: 0.12rem;
    }
    .btnbox {
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      justify-content: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      -ms-justify-content: center;
      -o-justify-content: center;
      position: relative;
      .mark {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
      .btn {
        border: none;
        outline: none;
        background: #EEEFF4;
        font-size: 0.12rem;
        color: #000000;
        width: 1.04rem;
        height: 0.31rem;
        padding: 0.03rem 0.19rem;
        border-radius: 0.155rem;
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        &.red {
          background: #FFC4CB;
          color: #FC0324;
        }
        img {
          width: 0.24rem;
          height: 0.24rem;
          margin-right: 0.06rem;
        }
        &:first-of-type {
          margin-right: 0.49rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/feedbackDetails.vue